import { GraphDefinition } from '../../coaching-insight/line-area.component';
import { MetricDataItem } from '../../performance-data/metric.pd.model';
import { createReducer } from '../../store.model';

import { createGraphSet } from './chart';
import { ChartType } from './chart-type.model';
import {
    calculateGap,
    getPercentages,
    getThreshold,
    getTrendName,
} from './detail';
import {
    ActionType,
    ReloadChart,
    ReloadChartCancel,
    ReloadChartResult,
    ReloadDetail,
    ReloadDetailCancel,
    ReloadDetailResult,
    SelectChart,
} from './pillar-three.action';
import { defaultState, PillarThreeState } from './pillar-three.state';

const { builder, reducer } = createReducer<ActionType, PillarThreeState>(
    defaultState(),
);

builder
    .add<ReloadChart>(
        ActionType.COACHING_DETAIL__P3__RELOAD_CHART,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    reloadChart: true,
                },
                userId: action.payload.userId,
                chartType: action.payload.chartType,
                periodTypeId: action.payload.periodTypeId,
                metricId: action.payload.metricId,
                goalId: action.payload.goalId,
                commitmentId: action.payload.commitmentId,
            };
        },
    )
    .add<ReloadChartResult>(
        ActionType.COACHING_DETAIL__P3__RELOAD_CHART_RESUlT,
        (state, action) => {
            let graphSet: GraphDefinition[];

            if (action.payload.chartType !== ChartType.DETAIL) {
                graphSet = createGraphSet(
                    action.payload.chartType,
                    action.payload.userSg,
                    action.payload.sg,
                    action.payload.goalHistory,
                    action.payload.goalEventHistory,
                );
            }

            return {
                ...state,
                pending: {
                    ...state.pending,
                    reloadChart: false,
                },
                graphSet,
            };
        },
    )
    .add<ReloadChartCancel>(
        ActionType.COACHING_DETAIL__P3__RELOAD_CHART_CANCEL,
        (state) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    reloadChart: false,
                },
            };
        },
    );

builder
    .add<ReloadDetail>(
        ActionType.COACHING_DETAIL__P3__RELOAD_DETAIL,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    reloadDetail: true,
                },
                userId: action.payload.userId,
                chartType: ChartType.DETAIL,
                periodTypeId: action.payload.periodTypeId,
                metricId: action.payload.metricId,
            };
        },
    )
    .add<ReloadDetailResult>(
        ActionType.COACHING_DETAIL__P3__RELOAD_DETAIL_RESUlT,
        (state, action) => {
            const periodPerf: MetricDataItem[] = [];
            action.payload.data.forEach((e) => {
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                if (e && e.length) {
                    const f = e.length - 1;
                    periodPerf.push(e[f]); // get last
                } else {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    periodPerf.push({} as MetricDataItem);
                }
            });

            const next = periodPerf.map((e) => {
                let l = { ...e } as any;

                getPercentages(l);

                if (l.trendName) {
                    l = getTrendName(l);
                }

                l.gap = calculateGap(l);
                l.gap = isNaN(l.gap) ? null : l.gap;
                l.opportunityThreshold = getThreshold();

                return l;
            });

            return {
                ...state,
                pending: {
                    ...state.pending,
                    reloadDetail: false,
                },
                dates: action.payload.dates,
                periodPerf: next,
            };
        },
    )
    .add<ReloadDetailCancel>(
        ActionType.COACHING_DETAIL__P3__RELOAD_DETAIL_CANCEL,
        (state) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    reloadDetail: false,
                },
            };
        },
    );

builder.add<SelectChart>(
    ActionType.COACHING_DETAIL__P3__SELECT_CHART,
    (state, action) => {
        return {
            ...state,
            chartType: action.payload.chartType,
            periodTypeId: action.payload.periodTypeId,
            metricId: null,
            commitmentId: null,
            graphSet: null,
            dates: [
                { startDate: null, endDate: null },
                { startDate: null, endDate: null },
                { startDate: null, endDate: null },
            ],
            periodPerf: [
                {} as any as MetricDataItem,
                {} as any as MetricDataItem,
                {} as any as MetricDataItem,
            ],
        };
    },
);

export const coachingDetailPillarThreeReducer = reducer;
